export default {
    ajaxCallInProgress: 0,
    success:0,
    config:{},
}


// WEBPACK FOOTER //
// ./src/store/initialState.js